
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { DataTransferObject_AcceptAssignmentNotificationDto, DataTransferObject_RejectAssignmentNotificationDto, AssignmentNotificationId } from "../../Shared/AssignmentNotification.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, RequestedValue$1, FormState_get_empty } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { acceptNotification, rejectNotification, getMailNotification } from "../../Requests/AssignmentNotification.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { uploadSignature } from "../../Requests/Files.js";

function assignmentNotificationId(notificationId) {
    return new AssignmentNotificationId(parse(notificationId));
}

export function init(notificationId) {
    return [new State(notificationId, FormState_get_empty(), new RequestedValue$1(0, []), undefined, undefined), getMailNotification(assignmentNotificationId(notificationId), (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
}

export function update(msg, state) {
    let xs, xs_2;
    switch (msg.tag) {
        case 2: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.NotificationId, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.NotificationId, FormState_get_empty(), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), (xs = ["accept-email-notification", "success"], Cmd_ofEffect((_arg) => {
                    RouterModule_nav(ofArray(xs), 1, 1);
                }))]))];
            }
        }
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.NotificationId, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.NotificationId, FormState_get_empty(), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), (xs_2 = ["accept-email-notification", "rejected"], Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(ofArray(xs_2), 1, 1);
                }))]))];
            }
        }
        case 1: {
            const dto_1 = new DataTransferObject_RejectAssignmentNotificationDto(undefined);
            return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), rejectNotification(assignmentNotificationId(state.NotificationId), dto_1, (Item_2) => (new Msg(3, [Item_2])), (Item_3) => (new Msg(8, [Item_3])))];
        }
        case 4:
            return [new State(state.NotificationId, state.FormState, new RequestedValue$1(1, [msg.fields[0]]), state.Signature, state.SignatureUrl), Cmd_none()];
        case 5:
            return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, msg.fields[0], state.SignatureUrl), Cmd_none()];
        case 6: {
            const matchValue_1 = state.Signature;
            if (matchValue_1 == null) {
                return [state, Cmd_none()];
            }
            else {
                const signature = matchValue_1;
                const formData = new FormData();
                formData.append(signature.name, signature);
                return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Signature, undefined), uploadSignature(formData, (Item_4) => (new Msg(7, [Item_4])), (Item_5) => (new Msg(8, [Item_5])))];
            }
        }
        case 7: {
            const response_2 = msg.fields[0];
            switch (response_2.tag) {
                case 0:
                    return [state, Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [state, Cmd_errorToast("general.a_error_occured")];
                default:
                    return [new State(state.NotificationId, state.FormState, state.AcceptEmailNotificationDetail, state.Signature, response_2.fields[0].ImageUrl), singleton((dispatch) => {
                        dispatch(new Msg(0, []));
                    })];
            }
        }
        case 8:
            return [state, Cmd_none()];
        default:
            if (state.AcceptEmailNotificationDetail.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const dto = new DataTransferObject_AcceptAssignmentNotificationDto(undefined, state.SignatureUrl);
                return [new State(state.NotificationId, FormState__startLoading(state.FormState), state.AcceptEmailNotificationDetail, state.Signature, state.SignatureUrl), acceptNotification(assignmentNotificationId(state.NotificationId), dto, (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
            }
    }
}

